
<template>
  <div id="container">
    <!-- <p>地图生成中...</p> -->
  </div>
</template>

<script>
import { dateFormat } from '@/utils/tools'
import Api from '@/api'

var vm = null
var AMap = window.AMap
export default {
  name: 'Amap',
  props: {
    tableData: {
      type: Object
    },
    mapData: {
      type: Array,
      default() {
        return []
      }
    },
    selfAreaId: {
      type: [String, Number]
    },
    selfAddress: {
      type: String
    },
    currMap: {
      type: [Array, Object]
    },
    fullPileNum: {
      type: Number
    },
    userLevel: {
      type: Number
    },
    showRatioEdit: {
      type: Boolean,
      default: false
    },
    ratioSites: {
      type: [Array],
      defalult() {
        return []
      }
    },
    tableDataBrands: {
      type: [Array]
    }
  },
  data() {
    return {
      key: '0b2718f15a7c8176bba6f4fdb787a101',
      markerContent: '',
      markerMap: {},
      map: {},
      infoWindow: {}, // 窗体只允许展示一个,
      currentData: null,
      mapList: [],
      layer: null,

      // 绘图相关
      geometries: [],
      geometriesNoRail: [],
      geometriesSite: [],
      geometriesOnStoppingFence: [], // 禁停区
      cachePolygon: [],

      // 缓存地图信息
      cacheMapZoom: null,
      cacheMapCenter: null
    }
  },
  mounted() {
    vm = this
  },
  methods: {
    jjSearchFromHistory(val) {
      if ((val && val.lon && val.lat) || (val && val.bikeLon && val.bikeLat)) {
        vm.map.setZoom(14)
        val.siteLon = val.lon || val.bikeLon
        val.siteLat = val.lat || val.bikeLat
        val.isBike = true
        val.isBikeShowInfo = true
        vm.initMap([val, ...vm.tableData.map], null, true)
      } else {
        vm.$message.warning('搜索不到您要的信息，请重新搜索')
      }
    },
    handleBikeSearch(val) {
      const vm = this
      if (val && val.isOutSite && val.isOutSite === 1 && val.bike && val.bike.bikeStatus === 1) {
        // 站外还车: 效果显示车辆图标，点击图片可以展示车辆品牌和车辆编号
        val.bike.isBikeShowInfo = true // 额外字段
        vm.jjSearchFromHistory(val.bike)
      } else if (val && !val.bike) {
        // 不在库里: 提示没有车辆数据 get
        vm.$message.warning('没有相关数据，请重新搜索')
      } else if (val && val.bike && val.bike.bikeStatus === 1) {
        // 在站点: 效果站点气泡放大，周围气泡保持不变 get
        // vm.jjSearchFromHistory(val.bike)
        if (val.map && val.map.length) { // 查看是不是在站点
          const data = val.map[0]
          vm.map.setZoom(14)
          vm.initMap(vm.tableData.map, data)
        } else {
          vm.$message.warning('该车辆不在站点')
        }
      } else if (val && val.isOutSite && val.isOutSite === 1 && val.bike && val.bike.bikeStatus === 2) {
        // 在出租中: 提示车辆出租中无法定位 get
        vm.$message.warning('车辆出租中无法定位')
      }
    },
    searchMap(val) {
      // 010579010129
      // val.map 模糊查询，val.bike 精准查询
      console.log('接口查询之后返回的站点数据:', val)
      if (val && val.map && val.map.length > 1 && !val.bike) { // 模糊查询
        vm.initMap(val.map)
      } else if (val && val.map && val.map.length === 1 && !val.bike) {
        const data = val.map[0]
        vm.initMap(vm.tableData.map, data)
      } else if (val && val.bike) { // 精准查询
        vm.handleBikeSearch(val)
      } else {
        if (val && val.bike === null) {
          vm.$message.warning('没有相关数据，请重新搜索')
        } else {
          vm.$message.warning('搜索不到您要的信息，请重新搜索')
        }
      }
    },
    delSiteAndShowMap(mapList, currentMap, isBike) {
      const vm = this
      if (vm.map && vm.map.destroy) vm.map.destroy()
      vm.map = null
      vm.map = new AMap.Map('container', {
        zoom: vm.cacheMapZoom,
        animateEnable: false,
        center: [vm.cacheMapCenter.lng, vm.cacheMapCenter.lat],
        viewMode: '2D',
        zoomEnable: true, // 是否可滚轮缩放
        dragEnable: true, // 是否可拖拽
        resizeEnable: false, // 是否监控地图容器尺寸变化
        keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
        doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
        showLabel: true,
        expandZoomRange: false,
        pitch: 60, // 3d有效
        showIndoorMap: false,
        mapStyle: 'amap://styles/normal' // 设置地图的显示样式
      })
      // 当前是根据areaid获取整个area的所有站点，此绑定方法废弃
      vm.map.on('zoomend', vm.zoomend)
      vm.map.on('movestart', vm.mapMovestart)
      vm.map.on('moveend', vm.mapMoveend)
      vm.showMapIcon(mapList, currentMap)
      // 初始化围栏 - 1
      if (this.userLevel >= 2) {
        this.getRails()
      }
    },
    mapMoveendBike() {
      this.map.addLayer(vm.layer)
    },
    initBikeMap(bikelist) {
      if (bikelist && bikelist.length) {
        if (vm.map && vm.map.destroy) vm.map.destroy()
        vm.map = null
        vm.map = new AMap.Map('container', {
          zoom: 14,
          animateEnable: false,
          center: [bikelist[0].bikeLon, bikelist[0].bikeLat],
          viewMode: '2D',
          zoomEnable: true, // 是否可滚轮缩放
          dragEnable: true, // 是否可拖拽
          resizeEnable: false, // 是否监控地图容器尺寸变化
          keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
          doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
          showLabel: true,
          expandZoomRange: false,
          pitch: 60, // 3d有效
          showIndoorMap: false,
          mapStyle: 'amap://styles/normal' // 设置地图的显示样式
        })
        // vm.map.on('zoomend', vm.zoomend)
        vm.map.on('movestart', vm.mapMovestart)
        vm.map.on('moveend', vm.mapMoveendBike)
        vm.layer = new AMap.LabelsLayer({
          map: vm.map,
          zooms: [3, 20],
          zIndex: 201,
          collision: false,
          allowCollision: false
        })
        // vm.map.add(vm.layer) // 图层添加到地图
        vm.map.addLayer(vm.layer)
        // mapList = mapList.slice(0, 500)
        var markers = []
        bikelist.forEach(mark => {
          const marker = new AMap.LabelMarker({
            name: mark.siteName,
            icon: {
            // 图标类型，现阶段只支持 image 类型
              type: 'image',
              // 图片 url
              image: 'https://media.winbaoxian.com/autoUpload/common/2_e1f364de7fe8f3c.png',
              // 图片尺寸
              size: [26, 36],
              // 图片相对 position 的锚点，默认为 bottom-center
              anchor: 'center'
            },
            opacity: 1,
            zooms: [3, 20],
            id: mark.siteId,
            position: [mark.bikeLon, mark.bikeLat],
            zIndex: 300
          })
          marker.on('click', vm.showBikeInfoMBikeFeiFa.bind(vm, mark))
          markers.push(marker)
        })
        vm.layer.add(markers)
      }
      // 初始化围栏 - 1
      if (this.userLevel >= 2) {
        this.getRails()
      }
    },
    initMap(mapList, currentMap, isBike, isMovedMap) {
      // todo 目前center写死
      // console.log(111, 'initMap', mapList, currentMap, isMovedMap)
      vm.mapList = mapList
      if (mapList && mapList.length) {
        const firstSite = mapList[0]
        if (!isMovedMap) {
          vm.map = new AMap.Map('container', {
            resizeEnable: true, // 允许缩放
            center: (currentMap && currentMap.siteId)
              ? [currentMap.siteLon, currentMap.siteLat]
              : (
                firstSite
                  ? [firstSite.siteLon, firstSite.siteLat]
                  : [116.397428, 39.90923]
              ), // 设置地图的中心点
            zoom: ((currentMap && currentMap.siteId) || isBike) ? 18 : 14, // 设置地图的缩放级别，0 - 20
            animateEnable: false,
            viewMode: '2D',
            zoomEnable: true, // 是否可滚轮缩放
            dragEnable: true, // 是否可拖拽
            keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
            doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
            showLabel: true,
            expandZoomRange: false,
            pitch: 60, // 3d有效
            showIndoorMap: false,
            mapStyle: 'amap://styles/normal' // 设置地图的显示样式
          })
        } else {
          vm.map.remove(vm.layer)
          vm.map.removeLayer(vm.layer)
          vm.clearSiteGpsRail()
        }
        // 当前是根据areaid获取整个area的所有站点，此绑定方法废弃
        vm.map.on('zoomend', vm.zoomend)
        vm.map.on('movestart', vm.mapMovestart)
        vm.map.on('moveend', vm.mapMoveend)
        vm.showMapIcon(mapList, currentMap)
        // 初始化围栏 - 1
        // 移动地图不需要重新禁行区和禁停区
        if (!isMovedMap && vm.userLevel >= 2) {
          vm.getRails()
        }
        // 如果是移动地图，重新绘制站点围栏
        if (isMovedMap) {
          vm.zoomend({ type: 'zoomend' })
        }
      } else {
        if (vm.selfAddress) {
          vm.markLocation('container', vm.selfAddress)
        } else {
          vm.markLocation('container', '')
        }
      }
    },
    zoomend(ev) {
      const zoom = this.map.getZoom()
      this.cacheMapZoom = zoom
      this.cacheMapCenter = this.map.getCenter()
      console.log('当前地图信息：', 'zoom: ', zoom, 'center: ', this.cacheMapCenter, ev)
      this.$emit('chearMapCenterTimer')
    },
    // 初始化围栏 - 1 / 2
    async getRails() {
      const vm = this
      const res = await vm.getRail()
      if (res && res.code === 200 && res.data && res.data.length) {
        vm.geometries = []
        res.data.forEach(item => {
          if (item.gpsRally && JSON.parse(item.gpsRally) && JSON.parse(item.gpsRally)[0] && JSON.parse(item.gpsRally)[0].id) {
            const gpsRally = JSON.parse(item.gpsRally)
            gpsRally.forEach(pgs => {
              const length = pgs.paths && pgs.paths.length
              if (length) {
                const paths = []
                pgs.paths.forEach(path => {
                  paths.push(new AMap.LngLat(path.lng, path.lat))
                })
                vm.geometries.push({ paths })
              }
            })
          }
        })
      }
      // 新版 - 禁停区
      const onStoppingFence = await vm.getOnStoppingFence()
      // console.log('onStoppingFence', onStoppingFence)
      if (onStoppingFence && onStoppingFence.code === 200 && onStoppingFence.data && onStoppingFence.data.length) {
        vm.geometriesOnStoppingFence = []
        onStoppingFence.data.forEach(item => {
          if (item.fence && JSON.parse(item.fence) && JSON.parse(item.fence).length) {
            const fence = JSON.parse(item.fence)
            const paths = []
            fence.forEach(pgs => {
              paths.push(new AMap.LngLat(pgs.lon, pgs.lat))
            })
            vm.geometriesOnStoppingFence.push({ paths })
          }
        })
      }

      // 禁行区
      const noRail = await vm.getForbiddenZone()
      if (noRail && noRail.code === 200 && noRail.data && noRail.data.length) {
        vm.geometriesNoRail = []
        noRail.data.forEach(item => {
          if (item.fence && JSON.parse(item.fence) && JSON.parse(item.fence).length) {
            const fence = JSON.parse(item.fence)
            const paths = []
            fence.forEach(pgs => {
              paths.push(new AMap.LngLat(pgs.lon, pgs.lat))
            })
            vm.geometriesNoRail.push({ paths })
          }
        })
      }
      vm.initRailMap()
    },
    // 新版禁停区
    getOnStoppingFence() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId,
          type: 0 // 0=禁停区,1=禁行区
        }
        Api.getForbidList(params)
          .then(res => {
            if (res.code === 200) {
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('获取新版禁停区：', err)
            reject(err)
          })
      })
    },
    // 禁行区
    getForbiddenZone() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId,
          type: 1 // 0=禁停区,1=禁行区
        }
        Api.getForbidList(params)
          .then(res => {
            if (res.code === 200) {
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('获取新版禁停区：', err)
            reject(err)
          })
      })
    },
    // 站点围栏绘图
    clearSiteGpsRail() {
      if (this.cachePolygon.length) {
        this.cachePolygon.forEach(polygon => polygon.hide())
        this.cachePolygon = []
      }
    },
    initSiteGpsRail() {
      vm.geometriesSite = []
      const siteList = []
      vm.mapList.forEach(item => {
        if (item.gpsRail) {
          const gpsRail = JSON.parse(item.gpsRail)
          if (gpsRail.length) {
            const paths = []
            gpsRail.forEach(path => {
              paths.push(new AMap.LngLat(path.lon, path.lat))
            })
            vm.geometriesSite.push({ paths })
            siteList.push(item)
          }
        }
      })
      // console.log('站点围栏集合', vm.geometriesSite, siteList)
      if (vm.geometriesSite && vm.geometriesSite.length) {
        vm.geometriesSite.forEach(path => vm.drawPolygon(path.paths, 'site'))
      }
    },
    // 统一调用绘图函数
    initRailMap() {
      // console.log('initMap', location)
      const vm = this
      // 初始化几何图形及编辑器
      if (vm.geometries && vm.geometries.length) {
        vm.geometries.forEach(path => vm.drawPolygon(path.paths, 'rail'))
      }
      if (vm.geometriesNoRail && vm.geometriesNoRail.length) {
        vm.geometriesNoRail.forEach(path => vm.drawPolygon(path.paths, 'noRail'))
      }
      // 禁停区
      if (vm.geometriesOnStoppingFence && vm.geometriesOnStoppingFence.length) {
        vm.geometriesOnStoppingFence.forEach(path => vm.drawPolygon(path.paths, 'onStoppingFence'))
      }
    },
    // 绘图函数
    drawPolygon(path, type) {
      const vm = this
      let strokeColor; let fillColor; let strokeStyle; let strokeWeight
      if (type === 'rail') {
        // 区域围栏边界颜色为蓝色
        strokeColor = '#1890FF'
        fillColor = ''
        strokeStyle = 'dashed'
        strokeWeight = 2
      } else if (type === 'noRail') {
        // 禁行区为红色边界红色阴影
        strokeColor = '#E6352C'
        fillColor = '#E6352C'
        strokeStyle = 'dashed'
        strokeWeight = 2
      } else if (type === 'site') {
        // 站点围栏为蓝色虚线加蓝色阴影
        strokeColor = '#1890FF'
        fillColor = '#1890FF'
        strokeStyle = 'dashed'
        strokeWeight = 1
      } else if (type === 'onStoppingFence') {
        // 禁停区为黄色虚线加黄色阴影
        strokeColor = '#FFC414'
        fillColor = '#FFC414'
        strokeStyle = 'dashed'
        strokeWeight = 1
      }
      const polygon = new AMap.Polygon({
        path: path,
        strokeColor,
        strokeWeight,
        strokeOpacity: 1,
        fillOpacity: 0.4,
        fillColor,
        strokeStyle
      })
      // 添加缓存
      if (type === 'site') {
        this.cachePolygon.push(polygon)
      }
      vm.map && vm.map.add(polygon)
    },
    // 获取区域围栏
    getRail() {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId,
          selectAreaId: vm.selfAreaId
        }
        Api.getRail(params)
          .then(res => {
            if (res.code === 200) {
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('获取区域围栏报错：', err)
            reject(err)
          })
      })
    },
    // 获取禁行区围栏
    getEntryRail(row) {
      const vm = this
      return new Promise((resolve, reject) => {
        const params = {
          selfAreaId: vm.selfAreaId,
          selectAreaId: vm.selfAreaId
        }
        Api.getEntryRail(params)
          .then(res => {
            if (res.code === 200) {
              resolve(res)
            } else {
              vm.$message.warning(res.message)
              reject(res)
            }
          })
          .catch(err => {
            console.log('获取区域围栏报错：', err)
            reject(err)
          })
      })
    },
    showMapIcon(mapList, currentMap) {
      const vm = this
      vm.layer = new AMap.LabelsLayer({
        map: vm.map,
        zooms: [3, 20],
        zIndex: 201,
        collision: false,
        allowCollision: false
      })
      // vm.map.add(vm.layer) // 图层添加到地图
      vm.map.addLayer(vm.layer)
      // mapList = mapList.slice(0, 500)
      const cMapList = JSON.parse(JSON.stringify(mapList))
      var markers = []
      // 虚拟站点处理
      if (currentMap && currentMap.siteId && currentMap.siteId.length === 13) {
        cMapList.unshift(currentMap)
      }
      cMapList.forEach(mark => {
        const marker = new AMap.LabelMarker({
          name: mark.siteName,
          icon: {
            // 图标类型，现阶段只支持 image 类型
            type: 'image',
            // 图片 url
            image: mark.isBike
              ? 'https://res.wyins.net/autoUpload/common/__f564ecf8fa75c1a.png'
              : vm.getIcon(vm.getSiteStatusByFlag(mark.flag).style, 'url', mark.bleNum === 1, mark),
            // image: mark.isBike ? 'https://res.wyins.net/autoUpload/common/__f564ecf8fa75c1a.png' : vm.getIcon(vm.getSiteStatus(mark.currentNum, mark.siteBikeCeiling).style, 'url', mark.bleNum === 1, mark),
            // 图片尺寸
            size: mark.bleNum === 1
              ? (
                ((currentMap && currentMap.siteId === mark.siteId) || mark.isBike)
                  ? [56, 76] // 自动车的icon
                  : [36, 54] // 放大站点
              )
              : (
                ((currentMap && currentMap.siteId === mark.siteId) || mark.isBike)
                  ? (mark.siteId && mark.siteId.length === 13)
                    ? [46, 58] // 虚拟站点放大图
                    : [36, 54]
                  : (mark.siteId && mark.siteId.length === 13
                    ? [36, 46] // 虚拟站点的图
                    : [26, 36]) // 正常站点
              ),
            // 图片相对 position 的锚点，默认为 bottom-center
            anchor: 'center'
          },
          opacity: 1,
          zooms: [3, 20],
          id: mark.siteId,
          position: [mark.siteLon, mark.siteLat],
          zIndex: mark.isBike ? 300 : vm.getSiteStatus(mark.currentNum, mark.siteBikeCeiling).zIndex,
          text: {
            content: mark.isBike ? '' : mark.currentNum + '',
            direction: 'center',
            offset: (mark.siteId && mark.siteId.length === 13) ? [-3, -3] : (mark.bleNum === 1 ? [-6, -6] : [0, -8]),
            style: {
              fontSize: 12,
              fillColor: '#666',
              strokeColor: 'white',
              strokeWidth: '5'
            }
          }
        })
        if (mark.isBikeShowInfo) {
          marker.on('click', vm.showBikeInfoM.bind(vm, mark))
        } else {
          marker.on('click', vm.showInfoM.bind(vm, mark))
        }
        markers.push(marker)
      })
      vm.layer.add(markers)
    },
    mapMoveend() {
      // var { lng, lat } = vm.map.getCenter() // 获取当前中心点的经纬度
      // vm.map.panTo(new AMap.LngLat(lng, lat))
      // console.log(lng, '-----', lat, '-----地图移动结束')
      // this.map.add(vm.layer)
      this.map.addLayer(vm.layer)
      // console.log(this.map.getCenter())
      this.$emit('refreshMap', this.map.getCenter())
    },
    mapMovestart(e) {
      this.map.remove(vm.layer)
      this.map.removeLayer(vm.layer)
      this.$emit('clearMapTimer')
    },
    getSiteStatusByFlag(flag) {
      // 修改前的状态： 0:空桩（蓝色）, 1:偏少（黄色）, 2:满桩（红色）, 3:偏多（橙色）, 4:正常（绿色）
      // 修改后的状态： 0:空桩, 1:正常, 2:满桩, 3:偏多, 4:偏少
      const obj = {
        style: '',
        status: ''
      }
      if (flag === 0) {
        obj.style = 0 // 空桩  蓝色icon
        obj.status = '空桩'
        obj.zIndex = 220
      } else if (flag === 4) {
        obj.style = 1 // 偏少  黄色icon
        obj.status = '偏少'
        obj.zIndex = 230
      } else if (flag === 3) {
        obj.style = 3 // 偏多  橙色icon
        obj.status = '偏多'
        obj.zIndex = 250
      } else if (flag === 2) {
        obj.style = 2 // 满桩  红色icon
        obj.status = '满桩'
        obj.zIndex = 260
      } else {
        obj.style = 4 // 正常  绿色icon
        obj.status = '正常'
        obj.zIndex = 240
      }
      return obj
    },
    getSiteStatus(curr, total) {
      const obj = {
        style: '',
        status: ''
      }
      // 修改前的状态： 0:空桩（蓝色）, 1:偏少（黄色）, 2:满桩（红色）, 3:偏多（橙色）, 4:正常（绿色）
      // 修改后的状态： 0:空桩, 1:正常, 2:满桩, 3:偏多, 4:偏少
      if (this.fullPileNum > 0) {
        if (curr === 0) {
          obj.style = 0 // 空桩  蓝色icon
          obj.status = '空桩'
          obj.zIndex = 220
        } else if (curr / (Math.floor(total * this.fullPileNum)) < 0.2) {
          obj.style = 1 // 偏少  黄色icon
          obj.status = '偏少'
          obj.zIndex = 230
        } else if (curr / (Math.floor(total * this.fullPileNum)) > 0.8 && curr / (Math.floor(total * this.fullPileNum)) < 1) {
          obj.style = 3 // 偏多  澄色icon
          obj.status = '偏多'
          obj.zIndex = 250
        } else if (curr / (Math.floor(total * this.fullPileNum)) >= 1) {
          obj.style = 2 // 满桩  红色icon
          obj.status = '满桩'
          obj.zIndex = 260
        } else {
          obj.style = 4 // 正常 绿色icon
          obj.status = '正常'
          obj.zIndex = 240
        }
        return obj
      }
      if (curr === 0) {
        obj.style = 0 // 空桩  蓝色icon
        obj.status = '空桩'
        obj.zIndex = 220
      } else if (curr / total < 0.2) {
        obj.style = 1 // 偏少  黄色icon
        obj.status = '偏少'
        obj.zIndex = 230
      } else if (curr / total > 0.8 && curr / total < 1) {
        obj.style = 3 // 偏多  橙色icon
        obj.status = '偏多'
        obj.zIndex = 250
      } else if (curr / total >= 1) {
        obj.style = 2 // 满桩  红色icon
        obj.status = '满桩'
        obj.zIndex = 260
      } else {
        obj.style = 4 // 正常  绿色icon
        obj.status = '正常'
        obj.zIndex = 240
      }
      return obj
    },
    showEcharts() {
      alert('showEcharts')
    },
    showWindowPop(site) {
      const data = this.mapList.find(item => item.siteId === site.siteId)
      if (data) {
        this.openInfo(data)
      }
    },
    openInfo(data) {
      // 构建信息窗体中显示的内容
      console.log('站点弹窗', data, vm.getSiteStatus(data.currentNum, data.siteBikeCeiling))
      vm.currentData = data
      let hasStationRatio
      if (vm.showRatioEdit && vm.ratioSites) {
        hasStationRatio = !this.ratioSites.find(item => item.siteId === data.siteId)
      }
      // console.log('vm.showRatioEdit', vm.showRatioEdit, 'vm.ratioSites', vm.ratioSites, 'hasStationRatio', hasStationRatio)
      let isVirtualSite = false
      if (data && data.siteId && data.siteId.length === 13) {
        isVirtualSite = true
      }
      var info = []
      // 修改前的状态： 0:空桩（蓝色）, 1:偏少（黄色）, 2:满桩（红色）, 3:偏多（橙色）, 4:正常（绿色）
      // 修改后的状态： 0:空桩, 1:正常, 2:满桩, 3:偏多, 4:偏少
      info.push(`
        <div class="map-title">
          <div class="title">${data.siteName}
            <span id='siteStatus' class="cursor ${
              data.flag === 0 // '空桩'
                ? 'blue map-title-tip'
                : (data.flag === 4
                  ? 'warning map-title-tip'
                  : (data.flag === 2
                    ? 'red map-title-tip'
                    : (data.flag === 3
                      ? 'origin map-title-tip'
                      : 'map-title-tip')))
            }">${vm.getSiteStatusByFlag(data.flag).status}</span>
            ${(vm.showRatioEdit && hasStationRatio) ? '<span class="des">勾选</span><input type="checkbox" id="ratioEdit"/>' : ''}
          </div>
        </div>
        <div class="map-content">
          <p class="content">站点编号：<span>${data.siteId}</span></p>
          <p class="content">创建时间：<span>${dateFormat(data.createTime, 'yyyy-MM-dd hh:mm:ss')}</span></p>
          <p class="content">
            道钉数：<span class="mt5">${data.bleNum}</span>
            车位数：<span class="mt5">${data.siteBikeCeiling}</span>
            现有车数：<span class="cursor" id="currentNum">${data.currentNum}<i class="iconfont cursor blue ml6">&#xe665;</i></span>
          </p>
        </div>
        <div class="map-content-box cursor">
          <div class="bike cursor" id="mapContentBoxBike">
            <p class="title cursor">自行车：${data.bikeNum}</p>
            ${vm.getBrandBikeHTML(data.brandBike)}
          </div>
          <div class="ebike cursor" id="mapContentBoxEBike">
            <p class="title cursor">电动车: ${data.ebikeNum}</p>
            ${vm.getBrandEBikeHTML(data.brandEBike)}
          </div>
        </div>
        <span class="amap-num">${data.currentNum}</span>
        ${isVirtualSite ? '<span id="delSiteBtn" class="del-site-btn">删除站点</span>' : ''}
      `)
      vm.infoWindow = new AMap.InfoWindow({
        content: info.join('<br/>'), // 使用默认信息窗体框样式，显示信息内容
        anchor: 'middle-left',
        offset: new AMap.Pixel(25, -10)
      })
      // infoWindow.on('open',showInfoOpen)
      // infoWindow.on('close',showInfoClose)
      console.dir(vm.infoWindow.dom)
      vm.$nextTick((data) => {
        document.getElementById('siteStatus').addEventListener('click', function() {
          vm.$emit('onInfoWindowClick', { ...vm.currentData, clickType: 3 })
        })
        document.getElementById('currentNum').addEventListener('click', function() {
          vm.$emit('onInfoWindowClick', { ...vm.currentData, clickType: 2 })
        })
        document.getElementById('mapContentBoxBike').addEventListener('click', function() {
          vm.$emit('onInfoWindowClick', { ...vm.currentData, clickType: 1, bikeType: 0 })
        })
        document.getElementById('mapContentBoxEBike').addEventListener('click', function() {
          vm.$emit('onInfoWindowClick', { ...vm.currentData, clickType: 1, bikeType: 1 })
        })
        if (document.getElementById('ratioEdit')) {
          document.getElementById('ratioEdit').addEventListener('click', function(e) {
            vm.$emit('onInfoWindowClick', { ...vm.currentData, clickType: 4, target: e })
          })
        }
        if (isVirtualSite) {
          document.getElementById('delSiteBtn').addEventListener('click', function(e) {
            vm.$emit('onInfoWindowClick', { ...vm.currentData, clickType: 5, target: e })
          })
        }
      })

      // map.getCenter() 是获取地图中心点的坐标，这里默认展示在地图中心。而不是标记点的位置
      vm.infoWindow.open(vm.map, new AMap.LngLat(data.siteLon, data.siteLat))
      setTimeout(() => {
        const eles = document.getElementsByClassName('amap-info')
        // console.log('eles', eles)
        const ele = eles && eles[0]
        if (ele) {
          ele.style.zIndex = 9999
        }
      }, 2000)
    },
    openBikeInfo(data) {
      // 构建信息窗体中显示的内容
      console.log('车辆弹窗', data)
      vm.currentData = data
      var info = []
      info.push(`
        <div style="height: 130px;">
          <div class="map-title">
            <div class="title">车辆信息</div>
          </div>
          <div class="map-content">
            <p class="content">车辆品牌：<span>${data.brandName}</span></p>
            <p class="content">车辆编号：<span>${data.bikeId}</span></p>
          </div>
        </div>
      `)
      vm.infoWindow = new AMap.InfoWindow({
        content: info.join('<br/>'), // 使用默认信息窗体框样式，显示信息内容
        anchor: 'middle-left',
        offset: new AMap.Pixel(25, -10)
      })
      // map.getCenter() 是获取地图中心点的坐标，这里默认展示在地图中心。而不是标记点的位置
      vm.infoWindow.open(vm.map, new AMap.LngLat(data.siteLon, data.siteLat))
    },
    showBikeInfoM(e) {
      const vm = this
      const data = vm.tableDataBrands.find(item => item.brandId === e.brandId)
      if (data) {
        e.brandName = data.brandName
        if (vm.infoWindow.close) {
          vm.infoWindow.close()
        }
        vm.openBikeInfo(e)
      } else {
        vm.infoWindow && vm.infoWindow.close()
      }
    },
    showInfoM(e) {
      if (e.isBike) {
        return false
      }
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId,
        siteId: e.siteId
      }
      Api.dashboardGetSite(params)
        .then(res => {
          if (res && res.code === 200) {
            const data = res.data
            var text = '您在 xx 的位置点击了marker！'
            // console.log(text, '------', data)
            if (data.siteId) {
              if (vm.infoWindow.close) {
                vm.infoWindow.close()
              }
              vm.openInfo(data)
            } else {
              vm.infoWindow.close()
            }
          } else {
            vm.$message.warning(res.message)
          }
        })
    },
    showBikeInfoMBikeFeiFa(e) {
      if (e) {
        if (vm.infoWindow && vm.infoWindow.close) {
          vm.infoWindow.close()
        }
        const data = JSON.parse(JSON.stringify(e))
        data.siteLon = e.bikeLon
        data.siteLat = e.bikeLat
        vm.openBikeInfo(data)
      } else {
        vm.infoWindow && vm.infoWindow.close()
      }
    },
    getIcon(index, key, bleNum, site) {
      // 虚拟站点 index=4，key='url',bleNum=false,site=13为
      // 根据站点编号，13位的是虚拟站点
      if (site && site.siteId && site.siteId.length === 13) {
        const style = [
          {
            url:
              'https://res.wyins.net/autoUpload/common/__36a822002bd6251.png',
            anchor: new AMap.Pixel(0, 0),
            size: new AMap.Size(26, 40)
          },
          {
            url:
              'https://res.wyins.net/autoUpload/common/__742e30b693a40ca.png',
            anchor: new AMap.Pixel(0, 0),
            size: new AMap.Size(26, 40)
          },
          {
            url:
              'https://res.wyins.net/autoUpload/common/__7112db58971a8b2.png',
            anchor: new AMap.Pixel(0, 0),
            size: new AMap.Size(26, 40)
          },
          {
            url:
              'https://res.wyins.net/autoUpload/common/__62c08fb4b58be6b.png',
            anchor: new AMap.Pixel(0, 0),
            size: new AMap.Size(26, 40)
          },
          {
            url:
              'https://res.wyins.net/autoUpload/common/__2c9341164ae5434.png',
            anchor: new AMap.Pixel(0, 0),
            size: new AMap.Size(26, 40)
          },
          {
            url: 'https://webapi.amap.com/theme/v1.3/markers/b/mark_bs.png',
            anchor: new AMap.Pixel(0, 0),
            size: new AMap.Size(19, 33)
          }
        ]
        return style[index][key]
      }
      // if (site && site.siteId === '010579010179') {
      //   console.log('实体站点', index, key, bleNum, site)
      // }
      // 有临字的
      if (bleNum) {
        const style = [
          {
            url:
              'https://res.wyins.net/autoUpload/common/__8562f67329d942c.png',
            anchor: new AMap.Pixel(0, 0),
            size: new AMap.Size(26, 40)
          },
          {
            url:
              'https://res.wyins.net/autoUpload/common/__caeb3e895f22349.png',
            anchor: new AMap.Pixel(0, 0),
            size: new AMap.Size(26, 40)
          },
          {
            url:
              'https://res.wyins.net/autoUpload/common/__5fb0cddcf9d082b.png',
            anchor: new AMap.Pixel(0, 0),
            size: new AMap.Size(26, 40)
          },
          {
            url:
              'https://res.wyins.net/autoUpload/common/__e288ac4282e6d2d.png',
            anchor: new AMap.Pixel(0, 0),
            size: new AMap.Size(26, 40)
          },
          {
            url:
              'https://res.wyins.net/autoUpload/common/__7523b8fdf475b5c.png',
            anchor: new AMap.Pixel(0, 0),
            size: new AMap.Size(26, 40)
          },
          {
            url: 'https://webapi.amap.com/theme/v1.3/markers/b/mark_bs.png',
            anchor: new AMap.Pixel(0, 0),
            size: new AMap.Size(19, 33)
          }
        ]
        return style[index][key]
      }
      // 无临字的
      const style = [
        {
          url:
            'https://res.wyins.net/autoUpload/activity/1_8f774ebeceb4ad7.png',
          anchor: new AMap.Pixel(0, 0),
          size: new AMap.Size(26, 40)
        },
        {
          url:
            'https://res.wyins.net/autoUpload/common/__d8686516dba2566.png',
          anchor: new AMap.Pixel(0, 0),
          size: new AMap.Size(26, 40)
        },
        {
          url:
            'https://res.wyins.net/autoUpload/common/__b12ce86106c8ee2.png',
          anchor: new AMap.Pixel(0, 0),
          size: new AMap.Size(26, 40)
        },
        {
          url:
            'https://res.wyins.net/autoUpload/common/__c97ad79b997aaaf.png',
          anchor: new AMap.Pixel(0, 0),
          size: new AMap.Size(26, 40)
        },
        {
          url:
            'https://res.wyins.net/autoUpload/common/__5595d02d389c79f.png',
          anchor: new AMap.Pixel(0, 0),
          size: new AMap.Size(26, 40)
        },
        {
          url: 'https://webapi.amap.com/theme/v1.3/markers/b/mark_bs.png',
          anchor: new AMap.Pixel(0, 0),
          size: new AMap.Size(19, 33)
        }
      ]
      return style[index][key]
    },
    getBrandBikeHTML(brandBike) {
      let strBrandBike = ''
      if (brandBike && brandBike.length) {
        for (let i = 0; i < brandBike.length; i++) {
          const temp = brandBike[i]
          strBrandBike += `<p class="com cursor">${
            temp ? temp.brandName : ''
          }：<span class="blue cursor">${temp.siteNum}</span></p>`
        }
      } else {
        strBrandBike = '<div style="color:#999;">暂无数据</div>'
      }
      return strBrandBike
    },
    getBrandEBikeHTML(brandEBike) {
      let strBrandEBike = ''
      if (brandEBike && brandEBike.length) {
        for (let i = 0; i < brandEBike.length; i++) {
          const temp = brandEBike[i]
          strBrandEBike += `<p class="com cursor">${
            temp ? temp.brandName : ''
          }：<span class="blue cursor">${temp.siteNum}</span></p>`
        }
      } else {
        strBrandEBike = '<div style="color:#999;">暂无数据</div>'
      }
      return strBrandEBike
    },
    // 关闭信息窗体
    closeInfoWindow() {
      vm.map && vm.map.clearInfoWindow && vm.map.clearInfoWindow()
    },
    markLocation(mapId, address) {
      const vm = this
      if (address === '永康市') {
        address = '永康市政府'
      } else if (address === '全国' || !address) {
        address = '北京市天安门'
      } else if (address === '朝阳区' && vm.selfAreaId === '110105') {
        address = '北京市朝阳区'
      }
      // console.log('mapId, address', mapId, address)
      AMap.plugin('AMap.Geocoder', function() {
        var geocoder = new AMap.Geocoder()
        geocoder.getLocation(address, function(status, result) {
          if (status === 'complete' && result.info === 'OK') {
            // 经纬度
            var lng = result.geocodes[0].location.lng
            var lat = result.geocodes[0].location.lat

            // 地图实例
            vm.map = new AMap.Map(mapId, {
              resizeEnable: true, // 允许缩放
              center: [lng, lat], // 设置地图的中心点
              zoom: 14, // 设置地图的缩放级别，0 - 20
              animateEnable: false,
              viewMode: '2D',
              zoomEnable: true, // 是否可滚轮缩放
              dragEnable: true, // 是否可拖拽
              keyboardEnable: false, // 键盘控制'↑' '→' '↓' '←'
              doubleClickZoom: true, // 地图是否可通过双击鼠标放大地图
              showLabel: true,
              expandZoomRange: false,
              pitch: 60, // 3d有效
              showIndoorMap: false,
              mapStyle: 'amap://styles/normal' // 设置地图的显示样式
            })
            // 添加标记
            var marker = new AMap.Marker({
              // icon: new AMap.Icon({
              //   image: 'https://res.wyins.net/autoUpload/activity/__8434e8d5c460f85.png',
              // }),
              map: vm.map,
              position: new AMap.LngLat(lng, lat) // 经纬度
            })
            // 初始化围栏 - 2
            if (vm.userLevel >= 2) {
              vm.getRails()
            }
          } else {
            console.log('定位失败1！')
          }
        })
      })
    }
  },
  watch: {
    currMap (val) {
      this.searchMap(val)
    }
  },
  beforeDestroy() {
    if (this.map && this.map.destroy) this.map.destroy()
    this.map = null
    this.closeInfoWindow()
    document.getElementById('currentNum') && document.getElementById('currentNum').removeEventListener('click', () => {})
    document.getElementById('mapContentBoxBike') && document.getElementById('mapContentBoxBike').removeEventListener('click', () => {})
    document.getElementById('mapContentBoxEBike') && document.getElementById('mapContentBoxEBike').removeEventListener('click', () => {})
  }
}
</script>

<style lang="less" >
#container {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 500px;
  z-index: -1;
  p {
    display: inline-block;
    color: #666;
  }

.map-title-tip {
  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  color:rgba(121,210,77,1);
  margin-left: 2px;
}
.amap-info-content {
  padding: 0;
}
.amap-info-close {
  position: absolute;
  right: 15px;
  top: 7px;
  color: #c3c3c3;
  text-decoration: none;
  font: inherit;
  width: 14px;
  height: 14px;
  cursor: pointer;
  font-size: 24px;
}
#container {
  .select-icon {
    position: absolute;
    top: 118px;
    left: -44px;
    font-size: 18px;
    display: inline-block;
    width: 45px;
    text-align: center;
  }

  .amap-num {
    position: absolute;
    top: 107px;
    left: -46px;
    display: block;
    width: 30px;
    text-align: center;
  }

  .del-site-btn {
    position: absolute;
    right: 0;
    bottom: 0;
    padding: 6px;
    z-index: 1;
    cursor: pointer;
    color: #FFF;
    /* border-bottom-right-radius: 6px; */
    border-radius: 4px;
    background-color: red;
  }

  .amap-icon {
    img {
      width: 30px;
      height: 45px;
    }
  }
}

#container .amap-marker-label {
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  border: 0;
  padding: 0;
  top: -100px !important;
  left: 46px !important;
  z-index: 300;
}

.map-title::after {
  position: absolute;
  top: 100px;
  left: -24px;
  content: "";
  width: 0;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 12px solid transparent;
  border-right: 12px solid #fff;
}

.map-title {
  // position: relative;
  // padding: 0 16px;
  // height: 48px;
  // align-items: center;
  // justify-content: space-between;
  // display: flex;
  // border-bottom: 1px solid #ebebeb;
  // margin-bottom: 16px;
  // margin-right: 40px;
  position: relative;
  align-items: center;
  justify-content: space-between;
  display: flex;
  border-bottom: 1px solid #ebebeb;
  max-width: 300px;
  margin: 10px 0 16px 0;
  padding: 0 40px 10px 16px;

  .title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
  }

  .close {
    display: inline-block;
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
    cursor: pointer;
  }

  .des {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    font-weight: 400;
  }

  #ratioEdit {
    margin-left: 5px;
    vertical-align: middle;
  }
}
.cursor {
  cursor: pointer;
}
.map-content {
  padding: 0 16px 13px 16px;

  .content {
    display: block !important;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.25);
    margin-bottom: 8px;

    span {
      color: #000;
    }

    span.mt5 {
      margin-right: 30px;
    }
  }
}

.map-content-box {
  display: flex;
  padding: 0 16px 16px 16px;

  div {
    flex: 1;

    p {
      display: block !important;
      margin-bottom: 8px;
    }
  }

  .bike,
  .ebike {
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.45);
    }

    .title {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #000 !important;
    }
  }
}
.ml6 {
  margin-left: 6px;
}
}
</style>
